import { BallotOutlined, ChromeReaderModeOutlined, DescriptionOutlined } from '@material-ui/icons';

// Demo-only menu group: Product, and Statement (with Template nested under it).
// Added to the sidebar only for demo accounts — see menu-items/index.js + utils/demoAccess.
export const buildDemoMenu = () => ({
    id: 'demo_group',
    title: 'Demo',
    caption: 'Prototype',
    type: 'group',
    children: [
        {
            id: 'demo_product',
            title: 'Product',
            type: 'item',
            url: '/demo/product',
            icon: BallotOutlined,
            breadcrumbs: false,
        },
        {
            id: 'demo_statement_section',
            title: 'Statement',
            type: 'collapse',
            url: '/demo/statement',
            icon: DescriptionOutlined,
            defaultOpen: true,
            children: [
                {
                    id: 'demo_template',
                    title: 'Template',
                    type: 'item',
                    url: '/demo/statement/template',
                    icon: ChromeReaderModeOutlined,
                    breadcrumbs: false,
                },
            ],
        },
    ],
});
